const en = {
    loginTitle: "Login",
    selectUser: "Select Login User",
    admin: "Admin",
    superAdmin: "Super Admin",
    mobileNumber: "Mobile Number",
    password: "*********",
    enterPassword: "Enter Password",
    rePassword: "Re-Enter Password",
    rememberMe: "Remember Me",
    forgotPassword: "Forgot Password?",
    loginButton: "Login",
    orLoginWith: "Or login with",
    google: "Google",
    apple: "Apple",
    dontHaveAccount: "Don't have an account?",
    signUp: "Sign Up",
    enterYourNumberToRecieveACode: "Enter your phone number to receive a code for resetting your password.",
    gender: "Gender",
    male: "Male",
    female: "Female",
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    verify: "Verify",
    email: "Email",
    twoStepVerification: "Two Step Verification",
    otpVerifyText: " For added security, please enter the One Time Password (OTP) that has been sent to mobile number.",
    verification: "Verification",
    pleaseWait: "Please wait for",
    seconds: "seconds",
    didntReceiveCode: "Didn't receive code?",
    resendCode: "Resend Code",
    getOtp: "Get OTP",
    createPassword: "Create New Password",
    passwordValidation: "New password must include at least one:",
    includesCharacters: "Includes 8-16 characters",
    includesNumber: "Number",
    includesSpecialChar: "Special character",
    includesLowercase: "Lowercase letter",
    includesUppercase: "Uppercase letter",
    welcome: "Welcome",
    welcomeDescription: `To become a leading center of excellence for research, training,
and data analysis on climate change and development in Africa.`,
    niccrra: "NICCRRA.",
    allCopyRightReserved: "All Rights Reserved.",

    // user profile 
    profile: "Profile",
    changePassword: "Change Password",
    logout: "Log out",
    editProfile: "Edit Profile",
    updateProfile: "Update Profile",

    // Side Menu Items
    dashboard: "Dashboard",
    farmers: "Farmers",
    taskAssignment: "Task Assignment",
    dataCollectors: "Data Collectors",
    reportSubmission: "Report Submission",
    userManagement: "User Management",
    roleManagement: "Role Management",
    regionAndLocality: "Region & Locality",
    typeOfCrops: "Types Of Crops",
    typeOfLivestock: "Types Of Livestock",
    typeOfPisciculture: "Types Of Pisiciculture",
    typeOfMachinery: "Types Of Machinery",
    certificationsAndTraining: "Certifications & Training",
    trainingProgram: "Training Programs",
    whoSponsored: "Who Sponsored The Training",

    // Dashboard Cards
    totalFarmersRegistered: "TOTAL Farmers Registered",
    pendingFarmerApprovals: "PENDING Farmer Approvals",
    taskAssignmentNotifications: "TASK Assignment Notifications",
    totalDataCollectors: "TOTAL Data Collectors",

    // Dashboard 
    performanceMetricsOfDataCollectors: "Performance Metrics Of Data Collectors",
    today: "Today",
    thisWeek: "This Week",
    thisMonth: "This Month",

    // Farmers 
    farmersList: "Farmers List",
    srNo: "Sr. No",
    photo: "Photo",
    farmerName: "Farmer Name",
    date: "Date",
    dataCollectorName: "Data Collector Name",
    mobileNo: "Mobile No.",
    location: "Location",
    statusView: "Status/View",
    clear: "Clear",
    selectStatus: "Select Status",
    approved: "Approved",
    pending: "Pending",
    reject: "Reject",
    selectTimePeriod: "Select Time Period",
    fromDate: "From Date",
    toDate: "To Date",
    today: "Today",
    week: "Week",
    month: "Month",
    year: "Year",
    selectLocation: "Select Location",
    selectFarmingCategory: "Select Farming Category",
    selectInfrastructureProximity: "Select Infrastructure Proximity",
    selectGender: "Select Gender",
    selectRegion: "Select Region",
    submit: "Submit",
    cancel: "Cancel",
    farmersDetailsView: "Farmers Details View",
    reject: "Reject",
    personalDetails: "Personal Details",
    locationDetails: "Location Details",
    farmingDetails: "Farming Details",
    farmOwnershipDetails: "Farm Ownership Details",
    accessToFinance: "Access to Finance",
    dateOfBirth: "Date of Birth",
    alternateMobileNumber: "Alternate Mobile Number",
    nationalIdentificationNo: "National Identification No.",
    address: "Address",
    latitude: "Latitude & Longitude",
    selectFarmingDetails: "Select Farming Details",
    filter: "Filter",
    rejectDescription: "Reject Description",
    pleaseSelectReasonForRejection: "Please select reason for rejection",
    pleaseEnterCommentForRejection: "Please enter comment for rejection",

    // Farming Details
    educationLevel: "Education Level",
    farmingExperience: "Farming Experience",
    farmSizeInHectares: "Farm Size in Hectares",
    typesOfCrops: "Types of Crops",
    cereals: "Cereals",
    legumes: "Legumes",
    rootsAndTubers: "Roots & Tubers",
    vegetables: "Vegetables",
    fruits: "Fruits",
    cashCrops: "Cash Crops",
    typesOfLivestock: "Types of Livestock",
    cattle: "Cattle",
    poultry: "Poultry",
    smallRuminants: "Small Ruminants",
    beefCattle: "Beef Cattle",
    chickens: "Chickens",
    goats: "Goats",
    typesOfPisciculture: "Types of Pisciculture",
    farmingMethods: "Farming Methods",
    years: "Years",
    hectares: "Hectares",

    // Farm Ownership Details
    farmOwnership: "Farm Ownership",
    ownership: "Ownership",
    owned: "Owned",
    titled: "Titled",
    leased: "Leased",
    untitled: "Untitled",
    infrastructureDetails: "Infrastructure Details",
    farmerHouse: "Farmer House",
    farmer: "Farmer",
    warehouse: "Warehouse",
    accessToRoadAndDistance: "Access to Road & Distance",
    available: "Available",
    notAvailable: "Not Available",
    processingPlants: "Processing Plants",
    typesOfMachinery: "Types of Machinery",
    tillageEquipment: "Tillage Equipment",
    industrial: "Industrial",
    mini: "Mini",
    handPush: "Hand Push",
    plows: "Plows",
    moldboard: "Moldboard",
    disc: "Disc",
    harrows: "Harrows",
    plantingEquipment: "Planting Equipment",
    speedDrills: "Seed Drills",
    planters: "Planters",
    transplanter: "Transplanter",
    rice: "Rice",
    vegetables: "Vegetables",
    agriculturalCertifications: "Agricultural Certifications",
    otherCertifications: "Other Certifications",
    otherTrainingPrograms: "Other Training Programs",
    whoSponsoredTheTraining: "Who Sponsored The Training ",
    otherTrainingSponsors: "Other Sponsored Training Program",
    sponsoredTraining: "Sponsored Training",
    

    // Access to Finance
    accessToFinance: "Access to Finance",
    loansFromGovernmentBank: "Loans from Government Bank",
    loansFromCommercialBank: "Loans from Commercial Bank",
    grantsFromINGOs: "Grants from iNGOs / Development Partner",
    emergencyContactDetails: "Emergency Contact Details",

    // Task Assignment
    taskAssign: "Task Assign",
    dataCollector: "Data Collector",
    description: "Description",
    region: "Region",
    state: "State",
    localGovernment: "Local Government",
    noOfFarmers: "Number of Farmers",
    deadline: "Deadline",
    completed: "Completed",

    // Task Assignment Form
    enterTaskTitle: "Enter Task Title",
    taskDescription: "Task Description",
    selectState: "Select State",
    selectLocalGovernment: "Select Local Government",
    selectDataCollector: "Select Data Collector",
    enterNumberOfFarmers: "Enter Number Of Farmers",
    notification: "Notification:",
    assignTask: "Assign Task",
    on: "ON",
    off: "OFF",
    pleaseEnterTaskTitle: "Please enter Task title",
    pleaseEnterTaskDescription: "Please enter Task description",
    pleaseSelectLocalGovernment: "Please select a Local Government",
    pleaseSelectDataCollector: "Please select Data Collector",
    pleaseEnterNumberOfFarmers: "Please enter No of farmers",
    numberOfFarmerCantBeDecimal: "Number of farmers can't be decimal",
    numberOfFarmerCantBeZero: "Number of farmers can't be zero",
    deadlineCantBePastDate: "Deadline can't be a past date",
    deadlineTooFarInFuture: "Deadline is too far in the future",
    pleaseEnterDeadline: "Please enter Deadline",
    fromDateCantBeGreaterThanToday: "From date cannot be greater than today's date",
    toDateCantBeGreaterThanToday: "To date cannot be greater than today's date",
    fromDateCantBeAfterToDate: "From date cannot be after to date",
    toDateCantBeBeforeFromDate: "To date cannot be before from date",
    editAssignTask: "Edit Assign Task",
  
    // Task Details
    taskDetailsView: "Task Details View",
    taskReportDetailsView : "Task Report Details View",
    status: "Status",
    sendReminder: "Send Reminder",
    farmersRegistered: "Farmers Registered",
    summary: "Summary",
    taskTitle: "Task Title",
    attachments: "Attachments",
    sendReminder: "Send Reminder",
    enterReminderTitle: "Enter Reminder Title",
    tasksReportSubmission: "Tasks Report Submission",
    yes: "Yes",
    no: "No",
    edit: "Edit",
    Update: "Update",
    delete: "Delete",

    // Data collectors
    addCollector: "Add Collectors",
    name: "Name",
    dataCollectorName: "Data Collector Name",
    active: "Active",
    inactive: "Inactive",
    pleaseEnterFirstName: "Please enter First name",
    pleaseEnterMiddleName: "Please enter Middle name",
    pleaseEnterLastName: "Please enter Last name",
    pleaseSelectGender: "Please select Gender",
    pleaseEnterMobileNumber: "Please enter Mobile number",
    pleaseEnterEmail: "Please enter Email",
    pleaseEnterValidEmail: "Please enter a valid Email",
    pleaseEnterPassword: "Please enter Password",
    pleaseReEnterPassword: "Please Re-enter password",
    passwordMismatch: "Password and confirm password is not same",
    passwordValidation:"Password must be 8-16 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.",

    //Crops
    demoFile: "Demo File",
    importFile: "Import File",
    addCrop: "Add Crop",
    EnterCropName: "Enter Crop",
    Cancel: "Cancel",
    editCrop: "Edit Crop",
    updateCrop: "Update Crop",
    deleteCrop: "Delete this Crop",
    cropdeleted: "Are you sure you want to",
    deleted: "delete this crop?",
    yes: "Yes",
    no: "No",
    ImportExcel: "Import Excel",

    // Region and Locality
    addRegion: "Add Region",
    addState: "Add State",
    addLocalGovernment: "Add Local Government",
    enterRegion: "Enter Region",
    enterState: "Enter State",
    enterLocalGovernment: "Enter Local Government",
    searchHere: "Search here",
    regionAndLocality: "Region & Locality",
    demoFile: "Demo File",
    importExcel: "Import Excel",
    submit: "Submit",
    cancel: "Cancel",
    pleaseSelectRegionName: "Please select a Region name",
    pleaseSelectRegion: "Please select a Region",
    pleaseEnterStateName: "Please enter a State name",
    pleaseSelectState: "Please select State",
    pleaseEnterLocalGovernmentName: "Please enter a Local Government name",
    noOptionAvailable : "No option avaiable",
    // Region Table 
    regionName: "Region Name",
    stateName: "State Name",
    localGovernmentName: "Local Government Name",
    editRegion: "Edit Region",
    editState: "Edit State",
    editLocalGovernment: "Edit Local Government",
    updateRegion: "Update Region",
    updateState: "Update State",
    updateLocalGovernment: "Update Local Government",
    deleteRegion: "Delete this Region",
    deleteState: "Delete this State",
    deleteLocalGovernment: "Delete this Local Government",
    deleteRegionConfirmation: "Are you sure you want to delete this Region?",
    deleteStateConfirmation: "Are you sure you want to delete this State?",
    deleteLocalGovernmentConfirmation: "Are you sure you want to delete this Local Government?",
    yes: "Yes",
    no: "No",
    cancel: "Cancel",
    submit: "Submit",
    edit: "Edit",
    delete: "Delete",
    pleaseEnterRegion: "Please enter a Region name",
    pleaseSelectRegionName: "Please select a Region name",
    pleaseEnterStateName: "Please enter a State name",
    pleaseEnterLocalGovernmentName: "Please enter a Local Government name",
    
    // user management
    role: "Role",
    activate: "Activate",
    deactivate: "Deactivate",
    update: "Update",
    approve: "Approve",

    //role management
    addRole: "Add Role",
    roleName: "Role Name",
    pleaseEnterRoleName: "Please enter Role name",
    userRole: "User Role",
    permissions: "Permissions",
    action: "Action",
    editRole: "Edit Role",
    updateRole: "Update Role",
    deleteRole: "Delete this Role",
    deleteRoleConfirmation: "Are you sure you want to delete this Role?",
    roleNameRequired: "Role name is required",

    downloadSuccess: "Downloaded successfully",

    // Livestock
    searchHere: "Search here",
    search: "Search",
    addLivestock: "Add Livestock",
    enterLivestock: "Enter Livestock",
    editLivestock: "Edit Livestock",
    updateLivestock: "Update Livestock",
    deleteLivestock: "Delete this Livestock",
    deleteLivestockConfirmation: "Are you sure you want to delete this Livestock?",

    // Pisiciculture 
    addPisciculture: "Add Pisciculture",
    enterPisciculture: "Enter Pisciculture",
    editPisciculture: "Edit Pisciculture",
    updatePisciculture: "Update Pisciculture",
    deletePisciculture: "Delete this Pisciculture",
    deletePiscicultureConfirmation: "Are you sure you want to delete this Pisciculture?",

    // Machinery
    addMachinery: "Add Machinery",
    enterMachinery: "Enter Machinery",
    enterSubCategory: "Enter Sub - Category",
    editMachinery: "Edit Machinery",    
    updateMachinery: "Update Machinery",
    deleteMachinery: "Delete this Machinery",
    deleteMachineryConfirmation: "Are you sure you want to delete this Machinery?",
    subCategory: "Sub - Category",

    // certifications and training
    addCertificationAndTraining: "Add Certification & Training",
    enterCertificationAndTraining: "Enter Certification & Training",
    editCertificationAndTraining: "Edit Certification & Training",
    updateCertificationAndTraining: "Update Certification & Training",
    deleteCertificationAndTraining: "Delete this Certification & Training",
    deleteCertificationAndTrainingConfirmation: "Are you sure you want to delete this Certification & Training?",

    // Training Program 
    typesOfTrainingProgram: "Types of Training Program",
    addTrainingProgram: "Add Training Program",
    enterTrainingProgram: "Enter Training Program",
    editTrainingProgram: "Edit Training Program",
    updateTrainingProgram: "Update Training Program",
    deleteTrainingProgram: "Delete this Training Program",
    deleteTrainingProgramConfirmation: "Are you sure you want to delete this Training Program?",

    // Who Sponsored
    addSponsor: "Add Sponsor",
    sponsoredName: "Sponsored Name",
    enterSponsor: "Enter Sponsor",
    editSponsor: "Edit Sponsor",
    updateSponsor: "Update Sponsor",
    deleteSponsor: "Delete this Sponsor",
    deleteSponsorConfirmation: "Are you sure you want to delete this Sponsor?",

    // Import excel 
    pleaseSelectFile: "Please Select File",

    // User profile validation
    firstNameIsRequired: "First name is required",
    middleNameIsRequired: "Middle name is required",
    lastNameIsRequired: "Last name is required",
    genderIsRequired: "Gender is required",
    mobileNumberIsRequired: "Mobile number is required",
    emailIsRequired: "Email is required",

    // No access
    youDontHaveAccess: "You don't have access",
}

export default en;